export function initializeCookieBanner() {
  // Предупреждение об использовании куки
  if (document.readyState !== 'loading') {
    if (document.querySelector('.cookie-banner')) {
      // функция возвращает cookie с именем name, если есть, если нет, то undefined
      function getCookie(name) {
        const matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
        return matches ? decodeURIComponent(matches[1]) : undefined;
      }
      const cookiecook = getCookie('BX_cookieok');
      const cookiewin = document.getElementsByClassName('cookie-banner')[0];
      // проверяем, есть ли у нас cookie, с которой мы не показываем окно и если нет, запускаем показ
      if (cookiecook != 'Y') {
        // показываем
        cookiewin.style.display = 'grid';
        // закрываем по клику
        document.getElementById('cookie-banner__btn').addEventListener('click', function() {
          cookiewin.style.display = 'none';
          // записываем cookie на 1 день, с которой мы не показываем окно
          const date = new Date();
          date.setMonth(date.getMonth() + 30);
          document.cookie = 'BX_cookieok=Y; path=/; expires=' + date.toUTCString();
        });
      }
    }
  }
}
